var map = {
  "./activity-empty.svg": "90955",
  "./add.svg": "17713",
  "./alert.svg": "34666",
  "./annotations.svg": "92414",
  "./answers-visible.svg": "59124",
  "./answers.svg": "57481",
  "./apps.svg": "78584",
  "./archive.svg": "18042",
  "./arrow-back.svg": "56309",
  "./arrow-double-down.svg": "51728",
  "./arrow-double-up.svg": "13187",
  "./arrow-down-bold.svg": "82872",
  "./arrow-down.svg": "16728",
  "./arrow-downward.svg": "5662",
  "./arrow-drop-down-circle.svg": "49125",
  "./arrow-drop-down.svg": "73976",
  "./arrow-forward.svg": "53995",
  "./arrow-left.svg": "12759",
  "./arrow-right.svg": "12882",
  "./arrow-up-bold.svg": "46253",
  "./arrow-up.svg": "41707",
  "./arrow-upward.svg": "8749",
  "./assignment.svg": "21411",
  "./attachment.svg": "6119",
  "./author.svg": "40641",
  "./auto-fix.svg": "4443",
  "./autorenew.svg": "67512",
  "./bar-chart.svg": "90608",
  "./bold.svg": "12673",
  "./bookmark.svg": "11728",
  "./calculator.svg": "79632",
  "./calender.svg": "13894",
  "./chapter-empty-two-layers.svg": "81161",
  "./chapter-empty.svg": "6003",
  "./checkmark-circle-fill.svg": "65002",
  "./checkmark-circle.svg": "2240",
  "./checkmark.svg": "47427",
  "./clock-progress.svg": "36694",
  "./code-braces.svg": "72608",
  "./code.svg": "27583",
  "./columns-2.svg": "13568",
  "./comment.svg": "98575",
  "./competencies.svg": "67911",
  "./content.svg": "12463",
  "./copy.svg": "85127",
  "./creation.svg": "53779",
  "./creative-commons.svg": "50146",
  "./cross-circle.svg": "49893",
  "./cross.svg": "45272",
  "./crown.svg": "94569",
  "./cursor.svg": "77006",
  "./dead.svg": "64378",
  "./desktop.svg": "40568",
  "./distribute-columns.svg": "52667",
  "./donut.svg": "2220",
  "./dot.svg": "10229",
  "./double-arrow.svg": "1507",
  "./draw.svg": "34190",
  "./ellipse-outline.svg": "20323",
  "./email.svg": "7864",
  "./enter.svg": "2162",
  "./entree-logo.svg": "52403",
  "./eraser.svg": "24272",
  "./excel.svg": "73833",
  "./exercises.svg": "86481",
  "./exit.svg": "93312",
  "./expand.svg": "65192",
  "./external-link.svg": "82242",
  "./eye-off.svg": "93207",
  "./eye.svg": "80479",
  "./feedback-filled.svg": "63246",
  "./feedback.svg": "34133",
  "./file-download.svg": "29751",
  "./file-upload.svg": "16504",
  "./file.svg": "1538",
  "./filter-list.svg": "86451",
  "./find-in-page.svg": "61913",
  "./flash-card.svg": "97005",
  "./folder.svg": "13076",
  "./formula.svg": "90438",
  "./fullscreen-exit.svg": "54740",
  "./fullscreen.svg": "12859",
  "./gift.svg": "30146",
  "./google-drive.svg": "3990",
  "./google-logo-color.svg": "35425",
  "./grid.svg": "16864",
  "./group-empty.svg": "98461",
  "./heading.svg": "1610",
  "./help-circle.svg": "44190",
  "./home.svg": "69141",
  "./horizontal-align-center.svg": "434",
  "./hyperlink.svg": "94646",
  "./ideal.svg": "3087",
  "./image.svg": "96711",
  "./indent.svg": "38626",
  "./info-circle.svg": "59353",
  "./italic.svg": "21712",
  "./justify-center.svg": "59950",
  "./justify-left.svg": "31314",
  "./justify-right.svg": "79465",
  "./key.svg": "21597",
  "./keyboard.svg": "34215",
  "./last-modified.svg": "38676",
  "./layer-folder.svg": "18764",
  "./learnbeat-no-label.svg": "48011",
  "./learnbeat.svg": "4874",
  "./learning-text.svg": "38314",
  "./leswijs.svg": "36057",
  "./library.svg": "54153",
  "./lightbulb-filled.svg": "48298",
  "./lightbulb-off.svg": "51965",
  "./lightbulb.svg": "67369",
  "./line.svg": "2630",
  "./loading.svg": "59116",
  "./local-cafe.svg": "14669",
  "./lock-open.svg": "13290",
  "./lock.svg": "75269",
  "./magister-logo.svg": "32818",
  "./menu.svg": "98501",
  "./merge-layers.svg": "69719",
  "./messageFrom.svg": "91481",
  "./messageTo.svg": "95406",
  "./microphone.svg": "26936",
  "./minus.svg": "20344",
  "./molsketch-benzene.svg": "21632",
  "./molsketch-bond-double.svg": "41472",
  "./molsketch-bond-single.svg": "80779",
  "./molsketch-bond-triple.svg": "6439",
  "./move.svg": "21559",
  "./notifications-active.svg": "66415",
  "./off.svg": "42191",
  "./office365-logo-color.svg": "43218",
  "./one-column.svg": "89915",
  "./orderedlist.svg": "59951",
  "./outdent.svg": "95839",
  "./palette.svg": "20509",
  "./pause.svg": "82078",
  "./pen.svg": "37153",
  "./pencil.svg": "68159",
  "./people-plus.svg": "15706",
  "./people.svg": "5841",
  "./periodic-table.svg": "79464",
  "./person-add.svg": "55609",
  "./person.svg": "69967",
  "./phone.svg": "8396",
  "./photo-library.svg": "50538",
  "./planner.svg": "42700",
  "./play-circle.svg": "64363",
  "./play.svg": "47342",
  "./plus-circle-filled.svg": "33318",
  "./plus-circle.svg": "54461",
  "./portfolio.svg": "74864",
  "./present.svg": "80249",
  "./presentation.svg": "5392",
  "./print.svg": "9445",
  "./progress.svg": "57329",
  "./qrcode.svg": "99366",
  "./queue.svg": "44973",
  "./quote-round.svg": "61179",
  "./quote.svg": "25892",
  "./rect-outline.svg": "81459",
  "./redo-arrow.svg": "60300",
  "./refresh.svg": "4569",
  "./reorder.svg": "68841",
  "./restart.svg": "36921",
  "./results.svg": "65482",
  "./school-building.svg": "98757",
  "./school.svg": "26396",
  "./search.svg": "22412",
  "./section-empty.svg": "42897",
  "./select-copy.svg": "71514",
  "./select-delete.svg": "10700",
  "./send.svg": "52730",
  "./server-saved.svg": "55435",
  "./server-syncing.svg": "28245",
  "./server-unsaved.svg": "31472",
  "./settings.svg": "5783",
  "./share-with-school.svg": "36687",
  "./share.svg": "32697",
  "./show.svg": "27395",
  "./shuffle.svg": "43619",
  "./sign-direction.svg": "80927",
  "./skip-next.svg": "28945",
  "./smartphone.svg": "13145",
  "./somtoday-color.svg": "20180",
  "./source-12.svg": "69769",
  "./source-13.svg": "44408",
  "./source-14.svg": "89335",
  "./source-4.svg": "18548",
  "./source-6.svg": "19286",
  "./source-7.svg": "6407",
  "./source-minus-1.svg": "69150",
  "./spinner.svg": "41167",
  "./stack.svg": "11560",
  "./star-rounded.svg": "76412",
  "./stop-circle.svg": "85973",
  "./stop.svg": "51624",
  "./subscript.svg": "3731",
  "./superscript.svg": "24156",
  "./support.svg": "93893",
  "./surf-logo-black.svg": "68846",
  "./swap-arrows.svg": "26684",
  "./swap.svg": "81105",
  "./symbol.svg": "14180",
  "./tab.svg": "55645",
  "./table.svg": "54484",
  "./tag.svg": "88656",
  "./take-in.svg": "58255",
  "./task-1.svg": "87113",
  "./task-11.svg": "85962",
  "./task-16.svg": "12725",
  "./task-2.svg": "88378",
  "./task-22.svg": "10916",
  "./task-25.svg": "73067",
  "./task-26.svg": "17880",
  "./task-28.svg": "16014",
  "./task-29.svg": "20767",
  "./task-30.svg": "79345",
  "./task-31.svg": "81312",
  "./task-32.svg": "25971",
  "./task-33.svg": "22242",
  "./task-34.svg": "50765",
  "./task-35.svg": "3404",
  "./task-36.svg": "82431",
  "./task-39.svg": "72216",
  "./task-40.svg": "56316",
  "./task-6.svg": "870",
  "./template.svg": "86550",
  "./text.svg": "26613",
  "./theory.svg": "39827",
  "./three-dots.svg": "29657",
  "./time.svg": "64387",
  "./timer.svg": "23835",
  "./training-empty.svg": "96094",
  "./translate.svg": "35458",
  "./trash.svg": "22838",
  "./trend-down.svg": "9954",
  "./trend-stable.svg": "32067",
  "./trend-up.svg": "68017",
  "./trophy.svg": "16974",
  "./two-columns.svg": "42172",
  "./two-rotating-arrows.svg": "94458",
  "./underline.svg": "70076",
  "./undo-arrow.svg": "79886",
  "./unorderedlist.svg": "70004",
  "./update.svg": "70731",
  "./user-clock.svg": "19860",
  "./volume-up.svg": "25976",
  "./warning-fill.svg": "51854",
  "./warning.svg": "58748",
  "./words-menu.svg": "70529",
  "./zoom-in.svg": "34711",
  "./zoom-out.svg": "27458"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98941;
